export { EntregaOcurreList } from "./list";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/list/index.ts